import { useEffect, useState } from "react";
import { API_DOMAIN } from "config";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API_DOMAIN}/admin/summary`)
      .then((r) => r.json())
      .then(setStats)
      .catch(console.error);
  }, []);

  if (!stats) {
    return (
      <div className="flex items-center justify-center h-[60vh] font-assistant text-gray-500">
        טוען נתוני מערכת…
      </div>
    );
  }

  const cards = [
    {
      label: "ספקים",
      value: stats.providers,
      icon: "🏭",
    },
    {
      label: "סוחרים",
      value: stats.dealers,
      icon: "🚗",
    },
    {
      label: "רכבים פעילים",
      value: stats.active_cars,
      icon: "📊",
    },
    {
      label: "הצעות ממתינות",
      value: stats.pending_offers,
      icon: "⏳",
    },
  ];

  return (
    <div className="p-6 space-y-6 bg-blue_gray-50 min-h-[calc(100vh-4rem)]" dir="rtl">
      <header className="flex flex-col gap-1 text-right">
        <h1 className="font-heebo text-2xl font-bold text-black-900_03">
          דשבורד מנהל
        </h1>
        <p className="text-sm font-assistant text-gray-700_04">
          תמונת מצב של המערכת – משתמשים, רכבים והצעות.
        </p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div
            key={c.label}
            className="relative overflow-hidden rounded-[20px] bg-white border border-gray-200 shadow-xs p-4 flex flex-col items-end"
          >
            <div className="relative flex items-center justify-between w-full">
              <div className="flex flex-col items-end gap-1">
                <span className="text-xs font-assistant text-gray-700_04">{c.label}</span>
                <span className="text-2xl font-bold font-heebo text-black-900_03">
                  {c.value ?? 0}
                </span>
              </div>
              <div className="h-10 w-10 rounded-[16px] bg-gray-50 flex items-center justify-center text-xl">
                {c.icon}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
